import { PreparedWorkload } from 'features/workload-optimization';

import { Typography } from '@cast/design-system';

export const PodsCell = ({ podCount, replicas }: PreparedWorkload) => {
  const isPositive = podCount === replicas;
  return (
    <Typography
      variant="P12R"
      color={!podCount ? 'grey.300' : isPositive ? 'green.500' : undefined}
      component="div"
      data-testid="pods"
      data-value={podCount}
    >
      {podCount || 'N/A'}
    </Typography>
  );
};
